import { useWindowResizeProvide } from './dumb/useWindowResize';
import { useViewTypeProvide } from './dumb/useViewType';
import { useAccountSlideOutProvide } from './features/useAccountSlideout';
import { useRegistrySlideOutProvide } from './features/useRegistrySlideout';
import { useSignInTooltipProvide } from './features/useSignInTooltip';
import { useMobileNavProvide } from './useMobileNav';

export function useProviders() {
  useMobileNavProvide();
  useWindowResizeProvide();
  useViewTypeProvide();
  useAccountSlideOutProvide();
  useSignInTooltipProvide();
  useRegistrySlideOutProvide();
}

export function useFooterOnlyProviders() {
  useWindowResizeProvide();
  useViewTypeProvide();
}
